import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext.tsx'
import { FlashcardsProvider } from './contexts/FlashcardsContext.tsx'
import ProtectedRoute from './components/ProtectedRoute.tsx'

import AuthForm from './components/AuthForm.tsx'
import AuthCallback from './components/AuthCallback.tsx'
import ReviewSession from './components/ReviewSession.tsx'
import VocabularyList from './components/VocabularyList.tsx'
import BCCWJBrowser from './components/BCCWJBrowser.tsx'
import WordTriage from './components/WordTriage.tsx'
import ProgressDashboard from './components/ProgressDashboard.tsx'
import LearningSession from './components/LearningSession.tsx'
import Layout from './components/Layout.tsx'
import Home from './pages/Home.tsx'
import Decks from './pages/Decks.tsx'

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<AuthForm />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<FlashcardsProvider><Layout /></FlashcardsProvider>}>
              <Route index element={<Home />} />
              <Route path="/review" element={<ReviewSession />} />
              <Route path="/learning" element={<LearningSession />} />
              <Route path="/decks" element={<Decks />} />
              <Route path="/vocabulary" element={<VocabularyList />} />
              <Route path="/bccwj" element={<BCCWJBrowser />} />
              <Route path="/triage" element={<WordTriage />} />
              <Route path="/progress" element={<ProgressDashboard />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
